import * as React from 'react'; 

export type MenuTriggerType = { role?: string } & React.FC<{ className?: string; id?: string; children: any }>;

export const MenuTrigger: MenuTriggerType = React.forwardRef((props, ref) => {
  if (props.children) {
    return <div key="menu-trigger" ref={ref as any}>{props.children}</div>;
  }
  return <>{props.children}</>;
});
MenuTrigger['role'] = "menu-trigger"; 